// Types for Petrol Requests (db/migrations/0950, 8001). Every figure, label and
// refusal comes from Postgres; this file only names the shapes.
import type { PaymentFile } from '../components/payments/PaymentFiles'

export type PetrolDriver = {
  id: string; name: string; status: string; phone: string | null; manager: string | null
  last_vehicle_id: string | null; last_shift?: string | null
}

/** advance: petrol for a shift. rebate: paying back a station when the Fuel Easy card was refused. */
export type PetrolKind = 'advance' | 'rebate'

export type PetrolOptions = {
  can_raise: boolean
  can_release: boolean
  releasers: string
  max_zar: number
  rebate_max_age_days: number
  today: string
  banks: string[]
  drivers: PetrolDriver[] | null
  vehicles: { id: string; label: string }[] | null
}

export type PetrolStatus = 'requested' | 'approved' | 'paid' | 'declined' | 'cancelled'

export type PetrolRequest = {
  id: string; ref: string; kind: PetrolKind; station_name: string | null
  status: PetrolStatus; amount_zar: number; reason: string; for_date: string
  driver_id: string; driver_name: string; vehicle: string | null
  payout_method: 'ewallet' | 'bank'; payout_text: string
  requested_by_name: string | null; requested_at: string; notified_at: string | null
  approved_at: string | null; approved_by_name: string | null
  declined_at: string | null; decline_reason: string | null
  paid_out_at: string | null; paid_out_method: 'marked' | 'emailed_proof' | null; paid_out_note: string | null; paid_out_by_name: string | null
  cancelled_at: string | null; cancel_reason: string | null
  proofs: { id: string; filename: string | null; received_at: string; from_email: string | null }[]
  has_receipt: boolean
  files: PaymentFile[]
}

export type PetrolList = {
  rows: PetrolRequest[]
  counts: { to_approve: number; to_pay: number; rebates_open: number; paid_this_month: number; paid_this_month_zar: number }
  fuel_spend: { month: string; registration: string; requests: number; amount_zar: number }[]
}

export const PETROL_STATUS_LABEL: Record<PetrolStatus, string> = {
  requested: 'Waiting for approval',
  approved: 'Approved, to pay',
  paid: 'Paid',
  declined: 'Declined',
  cancelled: 'Cancelled',
}

export const PETROL_STATUS_TONE: Record<PetrolStatus, 'green' | 'red' | 'amber' | 'neutral' | 'brand'> = {
  requested: 'amber',
  approved: 'brand',
  paid: 'green',
  declined: 'red',
  cancelled: 'neutral',
}

/** "2026-10-01" to "October 2026", in Johannesburg. */
export function formatMonth(iso: string): string {
  const d = new Date(`${iso.slice(0, 10)}T12:00:00+02:00`)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('en-ZA', { month: 'long', year: 'numeric', timeZone: 'Africa/Johannesburg' })
}
